<template>
    <div class="nft-item nft-show">
        <div
            id="nft-image-box"
            class="nft-image-box"
            v-bind:style="style"
        >
            <Cutscenes v-if="cutscenesState.isShow" />
            <Loading v-bind:isShow="!isLoaded" />
            <NftMask v-if="isLoaded && !isPlaying" v-on:click="toggleStart" />
            <div
                class="nft-image"
                v-bind:class="nftImageBgClass"
                v-on:click="toggleStart"
            >
                <template
                    v-for="(list, xi) of GifImageList"
                    v-bind:key="xi"
                >
                    <div
                        v-for="(item, idx) of list"
                        v-bind:key="`${xi}-${idx}`"
                        v-bind:class="[`jsgif-box-${xi}-${idx}`, item.isShow ? 'show' : '']"
                        class="jsgif-box"
                    >
                        <img
                            class="jsgif"
                            v-bind:class="[`jsgif-${xi}-${idx}`]"
                        >
                    </div>
                </template>
                <div class="cover-frame" />
            </div>

            <div class="nft-control">
                <!-- <button
                    v-for="item in synthMapDisplay"
                    v-bind:key="item.idx"
                    v-bind:class="{'active': currentIdx === item.idx}"
                    v-on:click="playSynth(item.idx)"
                >
                    {{ item.name }}
                </button>
                <h3>Build with EMs can be scaled down</h3> -->
                <ul class="Nav Nav_Small MainNav">
                    <!--  MainNav-Button_LeftOfActive -->
                    <li
                        v-for="item in synthMapDisplay"
                        v-bind:key="item.idx"
                        v-bind:class="{'MainNav-Button_Active': currentIdx === item.idx}"
                        class="MainNav-Button"
                        v-on:click="playSynth(item.idx)"
                    >
                        <a href="#">{{ item.name }}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import Libgif from 'libgif';
    import {
        reactive,
        onMounted,
        onUnmounted,
        computed,
        ref,
        watch,
        nextTick,
    } from 'vue';

    import Cutscenes from '@/components/Cutscenes.vue';
    import Loading from '@/components/Loading.vue';
    import NftMask from '@/components/NftMask.vue';
    import { getGifList, GifDisplayType } from '@/composable/useGifList';
    import { GlobalStore } from '@/store/GlobalStore';
    import { throttle } from '@/utils/debounce';
    import { useMdd } from '@/utils/useMdd';

    const GifImageList = reactive(getGifList());
    const { screenSize } = GlobalStore;
    const gifSelector = '.jsgif';

    const MAX_SIZE = 500;
    const MIN_SIZE = 300;
    const isFirstPlay = true;
    const isGifLoaded = computed(() => GifImageList[0].every(item => item.isLoaded) && GifImageList[1].every(item => item.isLoaded));
    // const isGifImgLoaded = computed(() => GifImageList.slice(0, 4).every(list => list.every(item => item.isImgLoaded)));
    // watch(isGifImgLoaded, (newVal) => {
    //     console.log('isGifImgLoaded', newVal);
    //     if (newVal) {
    //         initGifs(gifSelector);
    //     }
    // }, { immediate: true });
    const currentGifAxis = computed(() => {
        for (let xi = 0; xi < GifImageList.length; xi++) {
            const list = GifImageList[xi];
            for (let index = 0; index < list.length; index++) {
                const item = list[index];
                if (item.isShow) {
                    return [xi, index];
                }
            }
        }
        return [0, 0];
    });
    const gifCtrls: any[][] = [];

    const {
        beatEvent,
        stageEvent,
        playEvent,
        isLoaded: isMddLoaded,
        toggleStart,
        playSynth,
        currentIdx,
        isPlaying,
        keyMap,
    } = useMdd();
    const cutscenesState = reactive({
        isFirst: true,
        isShow: false,
        timeoutId: 0,
    });
    const isLoaded = computed(() => isMddLoaded.value && isGifLoaded.value);
    watch([isMddLoaded,
           isGifLoaded], (news) => {
               console.log('news', news);
           });

    const beatColor = ref('#008d5b');
    function randomColorFromArray(): string {
        const arr = ['#751c1c', '#2e397c', '#447230', '#72461a', '#56177a', '#d63a3a', '#566cd8', '#85d65f', '#d37f2a', '#a754dd'];
        return arr[Math.floor(Math.random() * arr.length)];
    }
    const style = computed(() => ({
        '--beat-color': '#d37f2a', // beatColor.value,
    }));
    beatEvent.addHandler(() => {
        // const color = Math.floor(Math.random() * 16777215).toString(16);
        // beatColor.value = `#${color}`;
        beatColor.value = randomColorFromArray();
        // console.log(beatColor.value);
    });
    playEvent.addHandler((evt: any) => {
        console.log(evt.detail);
        changeGif(evt.detail);
        beatColor.value = randomColorFromArray();
    });

    const synthMapDisplay = computed(() => {
        const arr: any = [];
        Object.entries(keyMap).forEach((val) => {
            val[1].forEach((v) => {
                arr.push({
                    key: val[0],
                    idx: Number(v.n) - 1,
                    keyCode: v.k,
                    name: v.name,
                });
            });
        });
        return arr;
    });
    watch(isPlaying, (newVal) => {
        const [x, y] = currentGifAxis.value;
        const gif = gifCtrls[x][y];
        newVal ? gif?.play() : gif?.pause();
    });

    const resizeNft = throttle(_resizeNft, 500);
    onMounted(() => {
        initGifs(gifSelector).then(() => {

        });
        resizeNft();

        window.addEventListener('resize', resizeNft);
        window.addEventListener('load', resizeNft);
    });

    onUnmounted(() => {
        window.removeEventListener('resize', resizeNft);
        window.removeEventListener('load', resizeNft);
    });
    //   0:30 ~ 0:32
    //   1:04 ~ 1:06
    //   1:20 ~ 1:22
    const currentStage = ref(0);
    stageEvent.addHandler((evt: any) => {
        const stage = Number(evt.detail);
        currentStage.value = stage;
        const [x, y] = currentGifAxis.value;

        changeCutscenes();
        setTimeout(() => {
            changeGif(y, currentStage.value);
        }, 500);
        console.log('stage', stage);
    });

    // function toggleGif() {
    //     const [x, y] = currentGifAxis.value;
    //     console.log('toggleGif', isFirstPlay, x, y, isPlaying.value);
    //     const gif = gifCtrls[x][y];
    //     isPlaying.value ? gif?.play() : gif?.pause();
    //     // for (let index = 0; index < gifImages.value.length; index++) {
    //     //     isPlaying.value ? gifCtrls[index]?.play() : gifCtrls[index]?.pause();
    //     //     const gif = gifImages.value[index];
    //     //     gif.isShow = idx === index;
    //     // }
    // }
    const nftImageBgClass = ref('nft-image-bg-1');
    function changeGif(synthType: number, stageId: number = currentStage.value) {
        console.log(isFirstPlay, 'changeGif', GifImageList, synthType, stageId, GifImageList[stageId][synthType].isShow);
        nftImageBgClass.value = `nft-image-bg-${synthType + 1}`;
        const [x, y] = currentGifAxis.value;
        if (stageId === x && synthType === y) {
            return;
        }
        GifImageList[stageId][synthType].isShow = true;
        const gif = gifCtrls[stageId][synthType];
        isPlaying.value ? gif?.play() : gif?.pause();
        GifImageList[x][y].isShow = false;
        gifCtrls[x][y]?.pause();
    }

    function changeCutscenes() {
        clearTimeout(cutscenesState.timeoutId);
        if (cutscenesState.isFirst) {
            cutscenesState.isFirst = false;
            return;
        }
        cutscenesState.isShow = true;
        screenSize.timeoutId = setTimeout(() => {
            cutscenesState.isShow = false;
        }, 2200);
    }

    function _resizeNft() {
        const { width, height } = screenSize.value;
        const size = Math.max(Math.min(width, height, MAX_SIZE), MIN_SIZE);
        const nftBox = document.getElementById('nft-image-box');
        if (nftBox) {
            nftBox.style.width = `${size}px`;
            nftBox.style.maxWidth = `${size}px`;
            nftBox.style.height = `${size}px`;
            nftBox.style.maxHeight = `${size}px`;
            nftBox.style.minHeight = `${size}px`;
        }
    }

    function getNftBoxSize() {
        const nftBox = document.getElementById('nft-image-box');
        if (nftBox) {
            const { width, height } = nftBox.getBoundingClientRect();
            return { width, height };
        }
        return { width: MAX_SIZE, height: MAX_SIZE };
    }

    async function initGifs(selector: string) {
        for (let xi = 0; xi < GifImageList.length; xi++) {
            const list = GifImageList[xi];
            if (xi >= 2) {
                const ctrls = [];
                for (let index = 0; index < list.length; index++) {
                    const item = list[index];
                    // eslint-disable-next-line no-await-in-loop
                    ctrls.push(await parseGif(`${selector}-${xi}-${index}`, item));
                }
                gifCtrls.push(ctrls);
            } else {
                const temp = list.map((item, index) => parseGif(`${selector}-${xi}-${index}`, item));
                // eslint-disable-next-line no-await-in-loop
                gifCtrls.push(await Promise.all(temp));
            }
        }
        console.log(gifCtrls);
    }

    function parseGif(selector: string, item: GifDisplayType) {
        return new Promise((resolve, reject) => {
            item.imgLoadPromise.then(() => {
                try {
                    const element = document.querySelector(selector);
                    const supergif = new Libgif({
                        gif: element,
                        progressbar_height: 0,
                        auto_play: false,
                    });
                    supergif.isShow = false;
                    supergif.load_url(item.url, () => {
                        console.log('load_url', item.url);
                        item.isLoaded = true;
                        resolve(supergif);
                    });
                } catch (error) {
                    reject(error);
                }
            }).catch(error => reject(error));
        });
    }

</script>

<style lang="scss">
  @import '@/scss/foundation/config';;
  // .section-studio {}
  .nft-control {
    z-index: 5;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    background-color: rgba(0, 0, 0, 0.5);

    display: flex;
    flex-direction:row;
  justify-content: space-between;

     button {
       cursor: pointer;
      //  margin: 0 10px;
     }

       button {
        //  color: white;
         color: rgb(150, 150, 150);
         display: inline-block;
         padding: .1rem;
         padding-top: .3rem;
         flex: 1 1 0;
         position: relative;
         text-align: center;
         font-size: 1.28em;
         background: rgba(0, 0, 0, 0.1);
         border-top: 3px solid rgba(255, 255, 255, 0.6);

        //  border: 2px solid white;
         transition: all 0.32s ease-in-out;

         &:not(:first-of-type) {
          //  border-left: 1px solid rgba(255,255,255,0.3);
         }

         &:hover {
           color: white;
            background: rgba(0, 0, 0, 0.2);
         }
       }

       button span {
         display: inline-block;

         width: 100%;
         height: 100%;

         padding: 1ex;

         color: white;

         transition: color 0.32s ease-in-out;
       }

      //  button:hover,
       button:focus,
       button.active {
         color: var(--beat-color);
         background-color: rgba(255, 255, 255, 0.3);
          // border-color: rgba(254, 114, 126, 0.9);
          border-color: var(--beat-color);
        //  box-shadow: 0 0 12px rgba(28, 28, 28, 0.48);
       }
       button:nth-of-type(1) {
         button {
           color: rgb(150, 150, 150);

           &:hover {
             color: rgb(0, 183, 250);
             background: rgba(0, 0, 0, 0.2);
           }
         }

         button:focus,
         button.active {
           color: rgb(255, 255, 255);
           background-color: rgba(0, 123, 255, 0.3);
           border-color: rgba(114, 205, 254, 0.9);
         }
       }
  }

  .nft-item {
    display: inline-block;
    width: 100%;
    height: 100%;
    max-width: 500px;
    max-height: 500px;
    // position: relative;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;

    .nft-image-box {
      width: 100%;
      min-height: 300px;
      max-height: 500px;
      position: relative;
      transition: background-color 106ms ease-in;
      background: radial-gradient(circle, rgba(0,0,0,0.39539565826330536) 0%, rgba(255,255,255,.3) 0%, rgba(0,0,0,0.3) 100%);
      background-color: var(--beat-color);

      .nft-image {
        z-index: 1;
        // padding: 1rem;
        background-size: cover;
        position: relative;
        width: 100%;
        height: 100%;
        &-bg-1 {
          background: url('@/assets/images/bg-1.png') no-repeat center center;
        }
        &-bg-2 {
          background: url('@/assets/images/bg-2.png') no-repeat center center;
        }
        &-bg-3 {
          background: url('@/assets/images/bg-3.png') no-repeat center center;
        }
        &-bg-4 {
          // background: url('@/assets/images/bg-4.png') no-repeat center center;
        }
        .jsgif-box {
          visibility: hidden;
          &.show {
            visibility: initial;
          }
        }
        .jsgif {
          position: absolute;
          top: 0;
          left:0;
          width: 100%;
          height: 100%;
          canvas {
            width: 100%;
            height: 100%;
          }

        }
        .cover-frame {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background: url('@/assets/images/frame.png') no-repeat center center;
          background-size: cover;
          z-index: 2;
        }

      }

      .nft-cover {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: auto;
      }

    }

  }

@media only screen and (max-width: 460px) {
.nft-item .nft-image-box .rec-item {
    width: 185px;
    height: 63px;
    .rectext {
      font-size: 40px;
    }
    .recdot {
          width: 26px;
    height: 26px;
    margin-right: 11px;
    margin-top: -3px;
    }
}
}
@media only screen and (max-width: 410px) {
  .nft-item .nft-image-box .rec-item {
      width: 167px;
      height: 57px;
      .rectext {
        font-size: 35px;
      }
      .recdot {
            width: 23px;
      height: 23px;
      margin-right: 10px;
      margin-top: -3px;
      }
  }
}

img.gif {
  visibility: hidden;
}

.gifcontrol {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  cursor: pointer;

  &:after {
    transition: background 0.25s ease-in-out;
    position: absolute;
    content: "";
    display: block;
    left: calc(50% - 25px);
    top: calc(50% - 25px);
  }

  &.loading {
    background: rgba(255, 255, 255, 0.75);
    &:after {
      background: #FF9900;
      width: 50px;
      height: 50px;
      border-radius: 50px;
    }
  }

  &.playing {
    /* Only show the 'stop' button on hover */
    &:after {
      opacity: 0;
      transition: opacity 0.25s ease-in-out;
      border-left: 20px solid #FF9900;
      border-right: 20px solid #FF9900;
      width: 50px;
      height: 50px;
      box-sizing: border-box;
    }
    &:hover:after {
      opacity: 1;
    }
  }

  &.paused {
    background: rgba(255, 255, 255, 0.5);
    &:after {
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 25px 0 25px 50px;
      border-color: transparent transparent transparent #ff9900;
    }
  }

  transition: background 0.25s ease-in-out;
  z-index: 100;

}

@keyframes bling-bg {
  0% {
    background: rgb(255, 255, 80);
  }
  25% {
    background: rgb(75, 250, 125);
  }
  50% {
    background: rgb(63, 137, 255);
  }
  75% {
    background: rgb(181, 67, 246);
  }
}

.bling-bg {
  background: rgba(255, 255, 255, 0.5);
  animation: bling-bg 968ms ease-in-out infinite alternate;
}
</style>
